import { useLoginModel } from "./loginDomain";
import { useEffect } from "react";
import { observer } from "mobx-react";

const LoginCallbackPage = observer(function LoginCallbackPage() {
  const { handleLoginCallback } = useLoginModel();
  useEffect(handleLoginCallback, [handleLoginCallback]);
  return <div />;
});

export default LoginCallbackPage;
